import { z } from "zod"

export const PauseDtoSchema = z
  .object({
    pausedAt: z.iso.datetime(),
    resumeAt: z.iso.datetime().nullable(),
    programAccessAllowed: z.boolean(),
  })
  .meta({ id: "PauseDtoSchema" })

export const PauseInputDtoSchema = z
  .object({
    durationInMonths: z.number().nullable(),
    programAccessAllowed: z.boolean().default(true),
  })
  .meta({ id: "PauseInputDtoSchema" })

export type PauseDto = z.infer<typeof PauseDtoSchema>
export type PauseInputDto = z.infer<typeof PauseInputDtoSchema>
